import { useEffect } from 'react'
import {
  type ComposeFeature,
  trackUnsupportedBrowserTab,
} from '@/core/kmp/unsupported-browser-analytics'
import { useActivePlan } from '@/features/plan/hooks/use-active-plan'
import { composeUiSupport } from '@/shared/lib/compose-ui-support'

/**
 * Reports an eligible person whose browser cannot run [feature] — counted wherever they are in the
 * app, not only once they open the tab. Pass eligibility only once it has settled.
 */
export function useReportUnsupportedBrowser(
  feature: ComposeFeature,
  isEligible: boolean,
) {
  const { activePlan } = useActivePlan()
  const planCode = activePlan?.code

  useEffect(() => {
    if (!isEligible) return
    const support = composeUiSupport()
    if (support.supported) return
    trackUnsupportedBrowserTab({ feature, reason: support.reason, planCode })
  }, [feature, isEligible, planCode])
}
